import html2canvas from 'html2canvas';
import { jsPDF } from "jspdf"
import Migra from '../fonts/Migra';
import MontserratItalic from '../fonts/MontserratItalic';
import Montserrat from '../fonts/Montserrat';

window.html2canvas = html2canvas;

const ConvertHTMLToPDF = async (options) => {

	const docWidth = options.docWidth || 210;
	const docHeight = options.docHeight || 475;
  const doc = new jsPDF('p', 'mm', [docHeight, docWidth]);

  const elementHTML = document.querySelector(options.selector);

  doc.html(elementHTML, {
      callback: (doc) => {
          doc.scale(options.scale || 0.8);
          doc.save(options.filename || "media-kit-export.pdf");
      },
      margin: options.margin || [10, 10, 10, 10],
      autoPaging: options.autoPaging || "text",
      x: options.x || 0,
      y: options.y || 0,
      width: options.width || 190,
      windowWidth: options.windowWidth || 975,
  });
}

export default ConvertHTMLToPDF;
